<template>
  <div class="app home-index">
    <header-child></header-child>
    <div class="swiper-out">
      <van-swipe :autoplay="4000">
        <van-swipe-item v-for="(item, index) in banner" :key="index">
          <div class="swiper-a" @click="goUrl(item.url)">
            <img v-lazy="item.img"/>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="home-content">
      <div class="hos-box clearfix">
        <div class="hos-li fl" v-for="(item, index) in logos" :key="index" @click="goItemHos(item.english_shortname)">
          <van-image :src="item.logo" alt="" class="hos-img" fit="contain"/>
        </div>
      </div>
    </div>
    <div class="footer fs14 index-footer" v-if="wx_wb.wb_thumb!=''&&wx_wb.wx_thumb!=''">
        <div class="fl" v-if="wx_wb.wb_thumb">
            <img :src="wx_wb.wb_thumb" alt="" class="qr-img">
            <p class="tc">官方微博</p>
        </div>
        <div class="fr" v-if="wx_wb.wx_thumb">
            <img :src="wx_wb.wx_thumb" alt="" class="qr-img">
            <p class="tc">官方微信</p>
        </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import HeaderChild from '@/components/HeaderChild'
import IndexFooter from '@/components/IndexFooter'
import {Swipe, SwipeItem,Lazyload ,Image } from 'vant'; 
// options 为可选参数，无则不传
Vue.use(Lazyload,{
  preLoad: 1.3,
  error: '../../static/default.png',
  loading: '../../static/loding.png',
  attempt: 1
});
export default {
  name: 'Index',
  mixins: [],
  components: {
    HeaderChild,
    IndexFooter,
    [Swipe.name]:Swipe,
    [SwipeItem.name]:SwipeItem,
    [Lazyload.name]:Lazyload,
    [Image.name]:Image
  },
  props: {},
  data () {
    return {
      banner: [],//banner
      menusList:[],//栏目
      logos:[],
      wx_wb:{}
    }
  },
  computed: {},
  watch: {},
  created(){
    this.getBanner();//获取首页banner
    this.getLogos();//获取手机端分院列表
    this.getContact();//获取微博微信二维码
  },
  mounted() {},
  destroyed() {},
  methods: {
    goItemHos(name){
      var url=window.location.href.split(this.$route.path)[0] + '/branch/index/'+name+'.html';
      window.open(url);
    },
    goUrl(url){
      if(url.length>0){
        window.location.href=url;
      }    
    },
    getContact(){
      this.$axios.post(this.api.about.contact,{},res =>{
        this.wx_wb=res.data;
        document.title=res.data.group_name||'集团化官网首页';
      },err =>{
        this.wx_wb={};
      });
    },
    getLogos(){
      this.$axios.post(this.api.about.subHospitals,{},res =>{
       this.logos=res.data;
      });
    },
    getBanner(){
      this.$axios.post(this.api.index.banners,{item:'Dynamic'},res =>{
        this.banner=res.data;
      });
    }
  }
}
</script>

<style>

</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.home-index{
  position:relative;
  padding-bottom:160px;
  .hos-box{
    padding:16px 16px 0;
    margin-bottom:8px;
    .hos-li{
      width:164px;
      height:132px;
      margin-right:15px;
      box-shadow:0px 0px 10px 0px rgba(0,0,0,0.1);
      border-radius:6px;
      margin-bottom:16px;
      padding:16px 32px;
    }
    .hos-li:nth-child(even){
      margin-right:0;
    }
    .hos-img{
      width:100px;
      height:100px;
    }
  }
}
.footer{
        position:absolute;
        bottom:0;
        left:0;
        width:100%;
        height:152px;
        background:#1A3039;
        padding:20px 60px;
        font-weight:400;
        color:rgba(255,255,255,1);
        line-height:20px;
        .qr-img{
            display: block;
            width:80px;
            height:80px;
            margin-bottom:8px;
        }
    }

</style>



// WEBPACK FOOTER //
// src/view/index.vue